import { Boundaries } from "@planzone/core";
import { Identifiable, Milestone } from "@planzone/dto";

function handleAssignTagRequest(
  milestone: Identifiable<Milestone>,
  { assignableId, tag }: Boundaries["assignTag"]["request"],
): Identifiable<Milestone> {
  return milestone.uuid === assignableId
    ? {
        ...milestone,
        tags: milestone.tags ? [...milestone.tags, tag] : [tag],
      }
    : milestone;
}

function handleAssignTagSuccess(
  milestone: Identifiable<Milestone>,
  { assignableId, tag }: Boundaries["assignTag"]["success"],
): Identifiable<Milestone> {
  if (milestone.uuid !== assignableId) return milestone;

  const tagExists = milestone.tags?.some(({ name }) => name === tag.name);

  return tagExists
    ? milestone
    : {
        ...milestone,
        tags: milestone.tags ? [...milestone.tags, tag] : [tag],
      };
}

function handleAssignTagFailure(
  milestone: Identifiable<Milestone>,
  { assignableId, tag }: Boundaries["assignTag"]["failure"],
): Identifiable<Milestone> {
  return milestone.uuid === assignableId
    ? {
        ...milestone,
        tags: milestone.tags.filter(({ name }) => name !== tag.name),
      }
    : milestone;
}

export {
  handleAssignTagRequest,
  handleAssignTagSuccess,
  handleAssignTagFailure,
};
